<div class="clear"></div>
<section class="banner">
    <div class="container py-4">
        <h1>
            PPRA-Trainings<br>
            <!-- <span class="text-success">UAN: 051-111-137-237</span> -->
        </h1>
    </div>
</section>
<section class="container">
    <div class="row">
        <div class="col-md-4 col-sm-6">
            <div class="bg-light h-100 p-4">
                <div class="nav flex-column list-group" id="training-tab" role="tablist" aria-orientation="vertical">
                    <a class="nav-link list-group-item list-group-item-action active" id="home-tab" data-toggle="pill"
                        href="#home" role="tab" aria-controls="home" aria-selected="true">
                        <h6>Home</h6>
                    </a>
                    <a class="nav-link list-group-item list-group-item-action" id="resource-persons-tab"
                        data-toggle="pill" href="#resource-persons" role="tab" aria-controls="resource-persons"
                        aria-selected="false">
                        <h6>Resource Persons</h6>
                    </a>
                    <a class="nav-link list-group-item list-group-item-action" id="training-modules-tab"
                        data-toggle="pill" href="#training-modules" role="tab" aria-controls="training-modules"
                        aria-selected="false">
                        <h6>Training Modules</h6>
                    </a>
                    <a class="nav-link list-group-item list-group-item-action" id="picture-gallery-tab"
                        data-toggle="pill" href="#picture-gallery" role="tab" aria-controls="picture-gallery"
                        aria-selected="false">
                        <h6>Registration</h6>
                    </a>
                </div>
            </div>
        </div>
        <div class="col-md-8 col-sm-7 py-4">
            <div class="tab-content" id="training-tabContent">
                <!---home--->
                <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                    <h3 class="pb-2">Introduction</h3>
                    <p>Since its inception in 2009, the Public Procurement Regulatory Authority (PPRA) has been
                        dedicated to enhancing transparency, efficiency, and compliance in public procurement. To
                        achieve this objective, PPRA has been actively conducting training programs on the regulatory
                        framework, equipping stakeholders with the necessary knowledge and skills to ensure adherence to
                        procurement rules and best practices.
                        Our training sessions cover key aspects of public procurement regulations, promoting
                        accountability and fair competition while minimizing risks of mismanagement. By fostering a
                        culture of compliance, PPRA aims to strengthen public sector procurement processes, ultimately
                        contributing to good governance and sustainable development.
                        Join our training programs to stay informed about the latest regulatory requirements and best
                        practices in public procurement.
                    </p>
                    <h5 class="font-weight-semi-bold">Training Programs for the Capacity building of Procuring Agencies
                        in Public Procurement</h5>
                    <ul>
                        <h5>1. Introductory Level Courses</h5>
                    </ul>
                    <div class="container mt-4">
                        <h2 class="mb-3 text-center">PPRA Training Programs</h2>

                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead class="table-primary">
                                    <tr>
                                        <th scope="col">Sr.</th>
                                        <th scope="col">Title</th>
                                        <th scope="col">Duration</th>
                                        <th scope="col">Offered By</th>
                                        <th scope="col">Contents</th>
                                        <th scope="col">For Registration & Queries</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>I</td>
                                        <td>Introduction to PPRA Regulatory Framework</td>
                                        <td>02 Days</td>
                                        <td>PPRA</td>
                                        <td>Introduction of PPRA regulatory framework (Act, Rules, Regulations, SBS,
                                            e-PADS, etc.)</td>
                                        <td>
                                            <strong>Focal Person:</strong> Syed Jahangir Rizvi<br>
                                            <strong>Phone:</strong> 051-9201843<br>
                                            <strong>Email:</strong> <a
                                                href="mailto:jahangir@ppra.org.pk">jahangir@ppra.org.pk</a><br>
                                            <strong>Website:</strong> <a href="https://old.ppra.org.pk"
                                                target="_blank">www.ppra.org.pk</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>II</td>
                                        <td>Certification Program in Public Procurement (Level-2)</td>
                                        <td>05 Days</td>
                                        <td>PPRA</td>
                                        <td>
                                            <ul>
                                                <li>Customization of SBDs (Works, Goods, Services, Consultancy,
                                                    Framework Agreements)</li>
                                                <li>Development of cost & quality-based bid evaluation criteria</li>
                                                <li>Drafting Bid Data Sheet, Specification Development</li>
                                                <li>Case studies on Grievance Handling & Arbitration</li>
                                                <li>e-PADS hands-on activities</li>
                                            </ul>
                                        </td>
                                        <td>
                                            <strong>Focal Person:</strong> Syed Jahangir Rizvi<br>
                                            <strong>Phone:</strong> 051-9201843<br>
                                            <strong>Email:</strong> <a
                                                href="mailto:iahanqir@ppra.org.pk">iahanqir@ppra.org.pk</a><br>
                                            <strong>Website:</strong> <a href="https://old.ppra.org.pk"
                                                target="_blank">www.ppra.org.pk</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>III</td>
                                        <td>Customized Training Program</td>
                                        <td>03 Days</td>
                                        <td>PPRA</td>
                                        <td>
                                            <ul>
                                                <li>PPRA Rules & Procurement Laws</li>
                                                <li>Drafting Bid Data Sheet & Specification Development</li>
                                                <li>Real-time case studies on Grievance Handling & Arbitration</li>
                                                <li>e-PADS Hands-on Training</li>
                                            </ul>
                                        </td>
                                        <td>
                                            <strong>Focal Person:</strong> Syed Jahangir Rizvi<br>
                                            <strong>Phone:</strong> 051-9201843<br>
                                            <strong>Email:</strong> <a
                                                href="mailto:iahanqir@ppra.org.pk">iahanqir@ppra.org.pk</a><br>
                                            <strong>Website:</strong> <a href="https://old.ppra.org.pk"
                                                target="_blank">www.ppra.org.pk</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>IV</td>
                                        <td>EPADS Training Program</td>
                                        <td>05 Days</td>
                                        <td>PPRA</td>
                                        <td>
                                            <ul>
                                                <li>Overview of EPADS & User Access Management</li>
                                                <li>Supplier Management System & Contract Finalization</li>
                                                <li>Hands-on Activity on Plan Creation, RFQ Process</li>
                                                <li>File Uploading & E-Submission for Open Competition</li>
                                            </ul>
                                        </td>
                                        <td>
                                            <strong>Focal Person:</strong> Syed Jahangir Rizvi<br>
                                            <strong>Phone:</strong> 051-9201843<br>
                                            <strong>Email:</strong> <a
                                                href="mailto:iahanqir@ppra.org.pk">iahanqir@ppra.org.pk</a><br>
                                            <strong>Website:</strong> <a href="https://old.ppra.org.pk"
                                                target="_blank">www.ppra.org.pk</a>
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <th colspan="2">Total</th>
                                        <th>15 Days</th>
                                        <th>PPRA</th>
                                        <th colspan="2">Covering all aspects of Public Procurement and EPADS system</th>
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!---Resource Persons--->
                <div class="tab-pane fade" id="resource-persons" role="tabpanel" aria-labelledby="resource-persons-tab">

                    <div class="container mt-4">
                        <h4 class="text-center mb-4 font-weight-bold">PPRA Resource Persons </h4>

                        <div class="row">
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Dr. Aslam Waseem</strong><br><em>Director General
                                            (Legal)</em></p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Mr. Farukh Bashir</strong><br><em>Director (Training)</em>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Mr. Abdul Nabi</strong><br><em>Director (Legal)</em></p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Dr. Faiza Nayyer</strong><br><em>Deputy Director (HR)</em>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Mr. Yasir Shammim</strong><br><em>Deputy Director
                                            (Finance)</em></p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Mr. Ali Temoor</strong><br><em>Deputy Director (M&E)</em>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Mr. Sagheer Ahmed</strong><br><em>Deputy Director
                                            (Training)</em></p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Syed Jahangir Rizvi</strong><br><em>Assistant Director
                                            (Training)</em></p>
                                </div>
                            </div>
                        </div>

                        <h4 class="text-center mt-5 mb-4 font-weight-bold">Master Trainers on EPADS</h4>

                        <div class="row">
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Mr. Farukh Bashir</strong><br><em>Director (Training)</em>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Mr. Ateeq Haider Baig</strong><br><em>Director (IT)</em></p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Dr. Faiza Nayyer</strong><br><em>Deputy Director (HR)</em>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Mr. Sagheer Ahmed</strong><br><em>Deputy Director
                                            (Training)</em></p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Mr. Ibrahim Rehman Khan</strong><br><em>Deputy Director
                                            (M&E)</em></p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Ms. Saima Mooed</strong><br><em>Deputy Director (M&E)</em>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Mr. Faraz Alvi</strong><br><em>Deputy Director
                                            (Finance)</em></p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Mr. Yasir Shammim</strong><br><em>Deputy Director
                                            (Finance)</em></p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Mr. Aasim Bashir</strong><br><em>Deputy Director (IT)</em>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Mr. Rizwan Mehmood</strong><br><em>Deputy Director (IT)</em>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6 pb-4">
                                <div class="p-3 border rounded bg-light">
                                    <p class="mb-0"><strong>Syed Jahangir Rizvi</strong><br><em>Assistant Director
                                            (Training)</em></p>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <!---Training Modules--->
                <div class="tab-pane fade" id="training-modules" role="tabpanel" aria-labelledby="training-modules-tab">
                    <h4 class="text-center mb-4 font-weight-bold">PPRA Training Modules</h4>

                    <table border="1" cellpadding="10" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th>Sr.</th>
                                <th>Title</th>
                                <th>Duration</th>
                                <th>Offered By</th>
                                <th>Contents</th>
                                <th>For Registration and Queries</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>I</td>
                                <td>Certificate in Procurement and Contract Management (Level-I)</td>
                                <td>05 Days at IBA (NIBAF) Islamabad</td>
                                <td>Accredited Institute / University</td>
                                <td>
                                    <ul>
                                        <li>Principles of Public Procurement</li>
                                        <li>Procurement Planning</li>
                                        <li>Formation of Bidding Documents (specification & bid evaluation criteria
                                            development)</li>
                                        <li>Contract drafting & contract negotiation</li>
                                        <li>Audit Observations, Comparison of PPRA Laws in Pakistan</li>
                                        <li>Exploring Markets and Trends</li>
                                        <li>Contract Management</li>
                                        <li>Approval Mechanism</li>
                                        <li>Case Studies</li>
                                        <li>e-Procurement (EPADS)</li>
                                    </ul>
                                </td>
                                <td>
                                    <strong>PPRA Focal Person:</strong> Syed Jahangir Rizvi, Asst. Director (Training)
                                    051-9201843 jahangir@ppra.org.pk<br>
                                    <strong>Mr. Waseem Afzaal:</strong> Joint Director (NIBAF) 051-9269778<br>
                                    <strong>Mr. Muhammad Bilal:</strong> Manager (IBA), Islamabad 0332-4060405<br>
                                    <strong>Email:</strong> registration@nibaf.gov.pk
                                </td>
                            </tr>
                            <tr>
                                <td>II</td>
                                <td>Certificate in Public Procurement Management (Level-I)</td>
                                <td>05 Days at LUMS, Lahore</td>
                                <td>Accredited Institute / University</td>
                                <td>
                                    <ul>
                                        <li>Introduction to PP Rules</li>
                                        <li>Annual Procurement Planning</li>
                                        <li>Requisition, Describing Requirements</li>
                                        <li>Identifying Suppliers</li>
                                        <li>Evaluating Offers, Consultancy Services</li>
                                        <li>Awarding, Administrating, and Closing Contracts</li>
                                        <li>E-Submission</li>
                                        <li>E-Evaluation</li>
                                    </ul>
                                </td>
                                <td>
                                    <strong>PPRA Focal Person:</strong> Syed Jahangir Rizvi, Asst. Director (Training)
                                    051-9201843 jahangir@ppra.org.pk<br>
                                    <strong>Mr. Waqas Mazhaar:</strong> Team Lead Custom Programme, REDC
                                    042-35608161<br>
                                    <strong>For Registration:</strong> Email: Waqas.mazhar@lums.edu.pk
                                </td>
                            </tr>
                            <tr>
                                <td>III</td>
                                <td>Certificate in Public Procurement Management (Level-I)</td>
                                <td>05 Days at NUST PDC, Islamabad</td>
                                <td>Accredited Institute / University</td>
                                <td>
                                    <ul>
                                        <li>Principles of Public Procurement</li>
                                        <li>Procurement Planning</li>
                                        <li>Formation of Bidding Documents (specification & bid evaluation criteria
                                            development)</li>
                                        <li>Identifying Suppliers</li>
                                        <li>Evaluating Offers, Consultancy Services</li>
                                        <li>Awarding, Administrating, and Closing Contracts</li>
                                    </ul>
                                </td>
                                <td>
                                    <strong>PPRA Focal Person:</strong> Syed Jahangir Rizvi, Asst. Director (Training)
                                    051-9201843 jahangir@ppra.org.pk<br>
                                    <strong>For Registration:</strong> Mr. Muhammad Ali, GM PDC (NUST) 0305-8529979,
                                    0301-8221543<br>
                                    <strong>Email:</strong> info@pdc.nust.edu.pk
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!---Registration --->
                <div class="tab-pane fade" id="picture-gallery" role="tabpanel" aria-labelledby="picture-gallery-tab">
                    <h3>For Registration</h3>
                    <table border="1" cellspacing="0" cellpadding="8">
                        <thead>
                            <tr>
                                <th>Sr No.</th>
                                <th>Training Module</th>
                                <th>No of Days</th>
                                <th>Registration Charges</th>
                                <th>Registration Focal Person</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Introduction to PPRA Regulatory Framework</td>
                                <td>02</td>
                                <td>Rs. 15,000/-</td>
                                <td>Syed Jahangir Rizvi, Asst. Director (Training) <br>051-9201843
                                    <br>jahangir@ppra.org.pk</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Certification Program in Public Procurement (Hands-on Program Level-2)</td>
                                <td>05</td>
                                <td>Rs. 25,000/-</td>
                                <td>Syed Jahangir Rizvi, Asst. Director (Training) <br>051-9201843
                                    <br>jahangir@ppra.org.pk</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Customized Training Program</td>
                                <td>03</td>
                                <td>Rs. 20,000/-</td>
                                <td>Syed Jahangir Rizvi, Asst. Director (Training) <br>051-9201843
                                    <br>jahangir@ppra.org.pk</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>EPADS USER Training</td>
                                <td>02</td>
                                <td>Rs. 10,000/-</td>
                                <td>Syed Jahangir Rizvi, Asst. Director (Training) <br>051-9201843
                                    <br>jahangir@ppra.org.pk</td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>EAPDS Master Trainer</td>
                                <td>05</td>
                                <td>Rs. 25,000/-</td>
                                <td>Syed Jahangir Rizvi, Asst. Director (Training) <br>051-9201843
                                    <br>jahangir@ppra.org.pk</td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>Certificate in Procurement and Contract Management (IBA-NIBAF, Islamabad)</td>
                                <td>05</td>
                                <td>-</td>
                                <td>Mr. Waseem Afzaal, Joint Director (NIBAF) <br>051-9269778 <br>Mr. Muhammad Bilal,
                                    Manager (IBA), Islamabad <br>0332-4060405</td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>Certificate in Procurement and Contract Management (NUST, Islamabad)</td>
                                <td>05</td>
                                <td>-</td>
                                <td>Mr. Muhammad Ali, GM PDC (NUST) <br>0305-8529979, 0301-8221543 <br>Email:
                                    info@pdc.nust.edu.pk</td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>Certificate in Public Procurement Management (LUMS)</td>
                                <td>05</td>
                                <td>-</td>
                                <td>Mr. Waqas Mazhaar, Team Lead Custom Programme, REDC <br>042-35608161 <br>Email:
                                    Waqas.mazhar@lums.edu.pk</td>
                            </tr>
                            <tr>
                                <td>9</td>
                                <td>Diploma in Procurement and Contract Management (Saturday Programme, NUST, Islamabad)
                                </td>
                                <td>4 Months</td>
                                <td>-</td>
                                <td>Mr. Muhammad Ali, GM PDC (NUST) <br>0305-8529979, 0301-8221543 <br>Email:
                                    info@pdc.nust.edu.pk</td>
                            </tr>
                        </tbody>
                    </table>

                </div>


                <!-- <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
					<h3 class="pb-3">Contact us</h3>
					<div class="row">
						<div class="col-lg-7">
							<h6 class="font-weight-semi-bold">For Nomination and Participation</h6>
							<h6>Dr. Faiza Nayyer</h6>
							<p class="text-black-50 font-weight-medium Roboto">Director (HR)-PPRA</p>
							<p>
								<i class="fas fa-map-marker-alt text-success mr-1"></i>1st Floor FBC Building,<br>
								<span class="ml-3">Sector G-5/2, Islamabad-Pakistan</span>
							</p>
							<p>
								<i class="fas fa-phone text-success mr-2"></i> 051-9224822<br>
								<i class="far fa-envelope text-success mr-2"></i><a href="mailto:faiza@ppra.org.pk">faiza@ppra.org.pk</a>
							</p>
						</div>
						<div class="col-lg-5">
							<h6 class="font-weight-semi-bold">For Training Queries</h6>
							<p>
								<i class="fas fa-phone text-success mr-2"></i> 051-9205726<br>
								<i class="fas fa-fax text-success mr-2"></i> 051-9219149<br>
								<i class="far fa-envelope text-success mr-2"></i><a href="mailto:training@ppra.org.pk">training@ppra.org.pk</a>
							</p>
						</div>
					</div>
				</div> -->
            </div>
        </div>
    </div>
</section>
<div class="clear"></div>